import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import {
    AccountLeads,
    ActivityDashboardDialogStore,
    ActivityDialogStore,
    ActivityHistoryDialogStore,
    ActivityNotesDialogStore,
    ActivityTemplateSelectionStore,
    CadenceListDialogStore,
    CadenceSelectionDialogStore,
    CompanyDialogStore,
    DailpadPopupStore,
    HistoryDetailsDialogStore,
    Lead,
    LeadScreenStore,
    NotesListDialogStore,
    QuickLeadDialogStore,
    SprintDialogStore,
    TaskListDialogStore,
    ViewType,
} from '../../../stores/LeadStore';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Grid from '@mui/material/Grid';
import DoActivityLeadInformation from './DoActivityLeadInformation';
import { LeadDataFormater } from 'src/features/leads/view/LeadDataFormater';
import { LeadAccountComponent } from 'src/features/leads/view/LeadAccountComponent';
import LeadForm from './LeadForm';

import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import Drawer from '@mui/material/Drawer';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Box, { BoxProps } from '@mui/material/Box';
import { useForm } from 'react-hook-form';
import Close from 'mdi-material-ui/Close';
import { v4 as uuidv4 } from 'uuid';
import { client } from 'src/utils/axios-client';
import { ProblemDetails } from 'src/types/ApiErrorResponse';
import { Button, IconButton, Tooltip } from '@mui/material';
import { useEffect } from 'react';
import { getLeadEndpoint, leadEndpoints } from 'src/configs/endpoints';
import { LeadListStore } from 'src/stores/LeadStore';
import _ from 'lodash';
import Paper, { PaperProps } from '@mui/material/Paper';
import paper from '../../../materio/@core/theme/overrides/paper';
import AccountLeadList from './AccountLeadList';
import ActivityHistoryList from './ActivityHistoryList';
import ActivityCadenceList from './ActivityCadenceList';
import ActivityNotes from './ActivityNotes';
import AddLeadToCadence from './AddLeadToCadence';
import DialPad from './DialPad';
import Draggable from 'react-draggable';
import LeadSummaryView from './LeadSummaryView';
import NotesView from './NotesView';
import TaskView from './TaskView';
import ActivityTemplateSelection from './ActivityTemplateSelection';

function PaperComponent(props: PaperProps) {
    return (
        <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...props} />
        </Draggable>
    );
}
const MyEnum = {
    xs: 'xs',
    sm: 'sm',
    md: 'md',
    lg: 'sm',
    xl: 'xl',
    false: false,
} as const;

type MyEnum = typeof MyEnum[keyof typeof MyEnum];

type Props = {
    open: boolean;
    onConfirm: () => void;
    onCancel: () => void;
    title: string;
    showIconButton: boolean;
    maxWidth: MyEnum;
};

export default function DoActivityAccountLeadDialog({
    open,
    onConfirm,
    onCancel,
    title,
    showIconButton,
    maxWidth,
}: Props) {
    const accountLeadMode = ActivityDialogStore.useState((s) => s.accountLeadMode);
    const sprintLeadMode = ActivityDialogStore.useState((s) => s.sprintLeadMode);
    const companyMode = CompanyDialogStore.useState((s) => s.companyMode);
    const sprintMode = CompanyDialogStore.useState((s) => s.sprintMode);
    const sprintDialogMode = SprintDialogStore.useState((s) => s.sprintDialogMode);
    const activityHistorDialogMode = ActivityHistoryDialogStore.useState((s) => s.activityHistorDialogMode);
    const miHistorDialogMode = ActivityHistoryDialogStore.useState((s) => s.miHistorDialogMode);
    const cadenceListDialogMode = CadenceListDialogStore.useState((s) => s.cadenceListDialogMode);
    const activityNotesDialogMode = ActivityNotesDialogStore.useState((s) => s.activityNotesDialogMode);
    const quickLeadDialogMode = QuickLeadDialogStore.useState((s) => s.quickLeadDialogMode);
    const notesDiealogMode = ActivityDashboardDialogStore.useState((s) => s.notesDiealogMode);
    const emailBodyDiealogMode = ActivityDashboardDialogStore.useState((s) => s.emailBodyDiealogMode);
    const smsBodyDiealogMode = ActivityDashboardDialogStore.useState((s) => s.smsBodyDiealogMode);
    const socialMediaDiealogMode = ActivityDashboardDialogStore.useState((s) => s.socialMediaDiealogMode);
    const notesText = ActivityDashboardDialogStore.useState((s) => s.notesText);
    const emailBodyText = ActivityDashboardDialogStore.useState((s) => s.emailBodyText);
    const smsBodyText = ActivityDashboardDialogStore.useState((s) => s.smsBodyText);
    const socialMediaText = ActivityDashboardDialogStore.useState((s) => s.socialMediaText);
    const selectedLead = LeadScreenStore.useState((s) => s.selectedLead);
    const notesListDialogMode = NotesListDialogStore.useState((s) => s.notesListDialogMode);
    const taskListDialogMode = TaskListDialogStore.useState((s) => s.taskListDialogMode);

    const activityTemplateSelectionMode = ActivityTemplateSelectionStore.useState(
        (s) => s.activityTemplateSelectionMode,
    );

    return (
        <Dialog
            fullWidth={true}
            maxWidth={maxWidth}
            open={open}
            onClose={onCancel}
            scroll="body"
            aria-labelledby="draggable-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperComponent={PaperComponent}
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                <Box
                    className="customizer-header"
                    sx={{
                        position: 'relative',
                        p: (theme) => theme.spacing(3.5, 5),
                        borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
                    }}
                >
                    <Typography sx={{ fontWeight: 600 }}>{title}</Typography>
                    {showIconButton && (
                        <IconButton
                            data-testid="close-button"
                            onClick={onCancel}
                            sx={{
                                right: 20,
                                top: '50%',
                                position: 'absolute',
                                color: 'text.secondary',
                                transform: 'translateY(-50%)',
                            }}
                        >
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    )}
                </Box>
            </DialogTitle>
            <DialogContent>
                <PerfectScrollbar options={{ wheelPropagation: false }}>
                    {accountLeadMode && (
                        <AccountLeadList
                            accountLeadMode={accountLeadMode}
                            sprintLeadMode={sprintLeadMode}
                            companyMode={companyMode}
                            sprintMode={sprintMode}
                            sprintDialogMode={sprintDialogMode}
                        />
                    )}
                    {sprintLeadMode && (
                        <AccountLeadList
                            accountLeadMode={accountLeadMode}
                            sprintLeadMode={sprintLeadMode}
                            companyMode={companyMode}
                            sprintMode={sprintMode}
                            sprintDialogMode={sprintDialogMode}
                        />
                    )}
                    {companyMode && (
                        <AccountLeadList
                            accountLeadMode={accountLeadMode}
                            sprintLeadMode={sprintLeadMode}
                            companyMode={companyMode}
                            sprintMode={sprintMode}
                            sprintDialogMode={sprintDialogMode}
                        />
                    )}
                    {sprintMode && (
                        <AccountLeadList
                            accountLeadMode={accountLeadMode}
                            sprintLeadMode={sprintLeadMode}
                            companyMode={companyMode}
                            sprintMode={sprintMode}
                            sprintDialogMode={sprintDialogMode}
                        />
                    )}
                    {sprintDialogMode && (
                        <AccountLeadList
                            accountLeadMode={accountLeadMode}
                            sprintLeadMode={sprintLeadMode}
                            companyMode={companyMode}
                            sprintMode={sprintMode}
                            sprintDialogMode={sprintDialogMode}
                        />
                    )}
                    {activityHistorDialogMode && (
                        <ActivityHistoryList
                            activityHistorDialogMode={activityHistorDialogMode}
                            miHistorDialogMode={miHistorDialogMode}
                        />
                    )}
                    {miHistorDialogMode && (
                        <ActivityHistoryList
                            activityHistorDialogMode={activityHistorDialogMode}
                            miHistorDialogMode={miHistorDialogMode}
                        />
                    )}
                    {cadenceListDialogMode && (
                        <div>
                            <ActivityCadenceList />
                        </div>
                    )}
                    {activityNotesDialogMode && <ActivityNotes />}
                    {selectedLead && quickLeadDialogMode && <LeadSummaryView item={selectedLead} />}

                    {notesDiealogMode && <Typography variant="body2">{notesText}</Typography>}
                    {emailBodyDiealogMode && <Typography variant="body2">{emailBodyText}</Typography>}
                    {smsBodyDiealogMode && <Typography variant="body2">{smsBodyText}</Typography>}
                    {socialMediaDiealogMode && <Typography variant="body2">{socialMediaText}</Typography>}
                    {notesListDialogMode && <NotesView />}
                    {taskListDialogMode && <TaskView />}
                    {activityTemplateSelectionMode && <ActivityTemplateSelection />}
                </PerfectScrollbar>
            </DialogContent>
        </Dialog>
    );
}
